import React, { useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Faq/Faq.css';

gsap.registerPlugin(ScrollTrigger);

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAccordion = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const items = [
    { 
      title: "What financial services do you offer?", 
      content: "We provide a comprehensive range of services including tax advisory, auditing, financial planning, business consulting, and compliance services. Our team is highly skilled in handling both personal and corporate financial matters." 
    },
    { 
      title: "How much do your services cost?", 
      content: "Our pricing depends on the complexity of the services required. We offer both fixed-fee and hourly rates for various services. For tax-related consultations and services, we also provide a free initial consultation." 
    },
    { 
      title: "What documents should I bring to my consultation?", 
      content: "Please bring all relevant financial documents, including tax returns, financial statements, business records, or any other documents that relate to your specific financial needs. This will help us provide accurate and tailored advice." 
    },
    { 
      title: "How long will it take to complete my financial plan?", 
      content: "The timeline depends on the scope of services and the complexity of your financial situation. We will discuss a detailed plan and timeline during your initial consultation to ensure we meet your needs efficiently." 
    },
    { 
      title: "Can I get financial advice over the phone?", 
      content: "We offer consultations over the phone for quick financial advice. However, for more in-depth services, a face-to-face or virtual meeting is recommended to better understand your financial goals and provide personalized advice." 
    },
    { 
      title: "What makes your financial advice unique?", 
      content: "Our financial advisors offer personalized services tailored to each client's specific financial goals, with an emphasis on practical solutions and long-term strategies for wealth management and business success."
    },
    { 
      title: "Do you provide services for both individuals and businesses?", 
      content: "Yes, we provide financial services for both individual clients and businesses, ensuring that we meet the specific financial needs of both personal and corporate sectors with effective solutions."
    },
  ];
  
  
  

  // GSAP Animations on scroll
  useEffect(() => {
    // Animating size change and movement of input fields
    gsap.to(".input-group input, .input-group select, form textarea", {
      scale: 1.1,
      x: 0,
      y: 5,
      duration: 0.5,
      ease: "power1.inOut",
      repeat: -1,
      yoyo: true,
      stagger: 0.3, // Stagger effect between each input field
    });
  }, []);

  return (
    <div className="full-faq">
      <div className="container-fa">
        <h2>Frequently Asked Questions</h2>
        <div className="accordion-fa">
          {items.map((item, index) => (
            <div className="accordion-item-fa" key={index}>
              <button
                aria-expanded={expandedIndex === index ? 'true' : 'false'}
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-title-fa">{item.title}</span>
                <span className="icon-fa" aria-hidden="true"></span>
              </button>
              {expandedIndex === index && (
                <div className="accordion-content-fa">
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="right-contact">
        <h1>Free Consultation</h1>
        <form className="contact-form">
          <div className="input-group">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
          </div>
          <div className="input-group">
            <input type="tel" placeholder="Your Phone" required />
            <select required>
  <option value="">Service Type</option>
  <option value="TaxAdvisory">Tax Advisory</option>
  <option value="FinancialPlanning">Financial Planning</option>
  <option value="AuditServices">Audit Services</option>
  <option value="Consulting">Consulting</option>
  <option value="OtherServices">Other Financial Services</option>
</select>

          </div>
          <textarea placeholder="Message" required></textarea>
          <button type="submit">Send Your Requirements</button>
        </form>
      </div>
    </div>
  );
};

export default FAQ;
